<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Manage Job Tasks</h3>

    <o-list-toolbar :filters-list="filter_list" :list-options="list_options"
                    :new-to="{name: 'job_task.create', params:{'id':0}}" :query-select-options="options"

                    :schema="schema" :search-fields-list="search_field_list"
                    :selected-filter="selected_filter"

                    new-button-text="New Job Task" @filter_changed="update_filter($event)"

                    @options_changed="update_table($event)" @reset_table="reset_table">

    </o-list-toolbar>

    <b-table :fields="fields" :items="items" :sort-by="list_options.sort" :sort-desc="list_options.order=='desc'" bordered class="o-list"
             head-variant="light"
             no-local-sorting striped thead-class="o-gradient-header"
             @sort-changed="change_sort">

      <template slot="cell(task_type)" slot-scope="{index, item}">
        <router-link :to="{name: 'job_task.edit', params: { id: item.id }}">
          <lookup-display :list="optionCodeJobTaskTypeItemsById" :value="item.task_type"
                          default-value="-" display-field="description"></lookup-display>
        </router-link>
      </template>
      <template slot="cell(expected_date)" slot-scope="{index, item}">
        <date-display :value="item.expected_date" format="DD/MM/YYYY hh:mm"></date-display>
      </template>
      <template slot="cell(when)" slot-scope="{index, item}">
        <date-display :value="item.when" format="DD/MM/YYYY"></date-display>
      </template>
      <template slot="cell(truck)" slot-scope="{index, item}">
        <lookup-display :list="optionCodeTruckItemsById" :value="item.truck" default-value="-"
                        display-field="name"></lookup-display>
      </template>
      <template slot="cell(trip_number)" slot-scope="{index, item}">
        <number-display :decimals="0" :value="item.trip_number"/>
      </template>
      <template slot="cell(notes)" slot-scope="{index, item}">
        <default-display :value="item.notes"></default-display>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{name: 'job_task.create'}">create a new item</router-link>
      </template>
    </b-table>

    <o-list-paging :limit="list_options.limit" :offset="list_options.offset" :page-options="rows_per_page_items"
                   :total-items="total_items"
                   @change-limit="change_limit"
                   @change-page="change_page"/>
  </div>
</template>

<style>
</style>

<script>
import {CreateCodeTableFetchMixin, CreateGroupPermissionMixin, CreateListPageMixin} from '../../../vue-ocom/mixins';
import {fieldToTableColumn, GetSearchFields} from "../../../vue-ocom/schema/schema_utils";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon, EmailIcon, LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay
  },
  mixins: [CreateListPageMixin('JobTask', 'job_task'),
    CreateGroupPermissionMixin('JobTask'),
    CreateCodeTableFetchMixin(['Job', 'CodeTruck', 'CodeJobTaskType',])
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(schema.JobTask, {}), /*Use this.schema instead */

      search_field_list: GetSearchFields(schema.JobTask),

      filter_list: [
        {'name': 'Active', 'code': 'active', options: {offset: 0, sort: "id"}},
        {'name': 'Non Active', 'code': 'inactive', options: {offset: 0, sort: "id"}},
        {'name': 'All', 'code': 'all', options: {offset: 0, sort: "id"}},
      ],
    }
  },
  computed: {
    options() {
      return {
        'Job': {'options': this.optionJobItems, 'textField': "", 'valueField': "id"},
        'CodeTruck': {'options': this.optionCodeTruckItems, 'textField': "name", 'valueField': "id"},
        'CodeJobTaskType': {
          'options': this.optionCodeJobTaskTypeItems,
          'textField': "description",
          'valueField': "id"
        },
      }
    },
    fields() {
      return this.filterTableColumns(this.schema, [
        fieldToTableColumn(this.schema, 'task_type'),
        fieldToTableColumn(this.schema, 'expected_date'),
        fieldToTableColumn(this.schema, 'when'),
        fieldToTableColumn(this.schema, 'truck'),
        fieldToTableColumn(this.schema, 'trip_number'),
        fieldToTableColumn(this.schema, 'notes'),
      ]);
    }
  }
}
</script>
